module.exports = __webpack_public_path__ + "img/Desktop - 12.72f781ee.svg";